<!-- 采购退补 -->
<template>
  <div class='page_content'>
    <processAuditAction ref="processAuditAction"></processAuditAction>
    <subComponents ref="showSelectData"></subComponents>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <vSearch @searchData="searchData" @openSearch="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
          <template slot="searchInput" slot-scope="{formOneValue}">
            <!-- 业务员	 -->
            <el-select filterable v-if="formOneValue.entityField == 'woamSalesman'" v-model="getRequestData[formOneValue.entityField]">
              <el-option label="全部" value="">
              </el-option>
              <el-option v-for="(values, keys) in userOneList" :key="keys" :label="values.opmName" :value="values.opmId">
              </el-option>
            </el-select>
          </template>
        </vSearch>
      </div>
    </div>
    <div class="page_content_center">
      <el-table v-if="pageShowData.jurTableVo" stripe size="mini" :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
        <el-table-column label="选择操作" width="80">
          <template slot-scope="scope">
            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
              <i class="el-icon-thumb"></i>
            </el-radio>
          </template>
        </el-table-column>
        <template v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable">
          <el-table-column align="center" v-if="tableValye.isShow==1" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
            <template slot-scope="scope">
              <!-- <span v-if="tableValye.fieldType == 'date'">
                <span v-if="scope.row[tableValye.entityField]">
                  {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                </span>
              </span> -->
              <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                        </span>
                        <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                        </span>
              <span v-else-if="tableValye.entityField == 'createTime'">
                <span v-if="scope.row[tableValye.entityField]">
                  {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                </span>
              </span>
              <span v-else-if="tableValye.entityField == 'rrmState'">
                <span v-for="item in JSON.parse(tableValye.formatterContent)">
                  <el-tag size="mini" v-if="item.key == scope.row.rrmState">{{item.value}}</el-tag>
                </span>
                <!-- {{JSON.parse(tableValye.formatterContent)[scope.row[tableValye.entityField]].value}} -->
              </span>
              <span v-else-if="tableValye.isRift == 1">
                <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
              </span>
              <span v-else>
                {{scope.row[tableValye.entityField]}}
              </span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme
  },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      seTitle: "",
      DialogVisible: false,
      seWidth: "",
      seId: "",
      fil: "",
      getRequestData: {
        rrmRapcus: "", // 供应商
        rrmRapcusName: "", // 供应商名称、
        smId: "",
        smName: "",
        opmId: "",
        opmName: "",
        page: 1,
        rows: 30,
        start: new Date(new Date().toLocaleDateString()).getTime() -
          31 * 24 * 3600 * 1000,
        end: new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1,
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      buttonList: [],
      pageShowData: [],
      selectedDataIndex: 0,
      parentSearchData: {},
      sField: "",
      requesUrl: "",
      ormId: JSON.parse(sessionStorage.getItem('userInfo')).ormId
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.rrmRapcusName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.rrmRapcus = "";
        }
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    // 检索Id, 索引(表格中), 标识
    openSearch({ sId, index, type, sField }) {
      this.DialogVisible = true;
      this.seId = sId;
      this.sField = sField;
      this.parentSearchData[type] = this.getRequestData[type];
    },
    //检索带回数据
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val);
      }
    },
    // 赋值字段
    paramValue(val) {
      console.log(this.sField);
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.getRequestData[item] = val[item];
      });
    },
    changeTime(val) {
      if (val) {
        var time = val + 24 * 60 * 60 * 1000 - 1;
        this.getRequestData.end = time;
      }
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页
        var isPenetrate = true;
        // 设置缓存 存入点击单号
        this.resetSetItem("penetrateOrderId", orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({
          //向窗口发送MessageEvent消息
          cmd: "returnFormJson",
          params: {
            isPenetrate
          }, //参数
        },
          "*"
        );
      }
    },
    openSeComponents(e, num, fil, field) {
      this.seId = e;
      this.fil = fil;
      this.DialogVisible = true;
      this.parentSearchData[field] = this.getRequestData[field];
    },
    getSeData(val) {
      console.log(val);
      if (this.fil == "smId") {
        this.getRequestData.smName = val.smName;
        this.getRequestData.smId = val.smId;
      } else if (this.fil == "opmId") {
        this.getRequestData.opmId = val.opmId;
        this.getRequestData.opmName = val.opmName;
      }
      this.DialogVisible = false;
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    isShowData(name, value) {
      console.log(name);
      switch (name) {
        case "rrmRapcus":
          var dataInfo = sessionStorage.getItem("selectSupplierData");
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo);
            this.getRequestData.rrmRapcus = dataInfo.smId;
            this.getRequestData.rrmRapcusName = dataInfo.smName;
          }
          break;
        default:
          this.sendDataInfo[name] = value;
      }
    },

    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path);
      let responseData = await this.$http.getJur({
        ids: [pathId.jurId]
      });
      if (responseData.status == 200) {
        this.getButtonList();
        this.pageShowData = responseData.result;
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.getDataList();
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    clear(val) {
      if (val) {
        var arr = val.split(",")
        arr.forEach(item => {
          this.$set(this.getRequestData, item, "")
        })
      }
    },
    // 动作集合
    actionSet(actionData) {
      if (actionData.actionType != 15 && actionData.actionType != 9) {
        if (this.returnData.list.length <= 0) {
          if (!dataInfo) {
            this.$message({
              message: "暂无数据",
              type: "error",
            });
            return false;
          }
        }
        if (!this.returnData.list[this.selectedDataIndex]) {
          this.$message({
            message: "请先选择您要操作的数据",
            type: "error",
          });
          return false;
        }
        var dataInfo = JSON.parse(
          JSON.stringify(this.returnData.list[this.selectedDataIndex])
        );
      }
      switch (actionData.actionType) {
        case 4:
          this.$refs["processAuditAction"].openBox(0, dataInfo.rrmId);
          break;
        case 5:
          this.$refs["processAuditAction"].openBox(1, dataInfo.rrmId);
          break;
        case 7:
          this.puBackPuRrapplyGoBack();
          break;
        case 9:
          this.exportFun()
          break;
      }
    },
    async exportFun() {
      this.getRequestData.page = 1;
      await this.getDataList()
      if (this.returnData.list.length == 0) {
        this.$message({ type: 'error', message: "暂无数据！" })
        return
      }
      window.location.href = this.requesUrl + '/ReturnRepair/exportOrderHisData?ormId='
        + String(this.ormId) + '&smId=' + this.getRequestData.smId
        + '&start=' + this.getRequestData.start + '&end=' + this.getRequestData.end
        + '&page=' + this.getRequestData.page + '&rows=' + this.getRequestData.rows + '&origin=' + this.getRequestData.origin
        + '&smName=' + this.getRequestData.smName + '&rrmRapcus=' + this.getRequestData.rrmRapcus
        + '&rrmRapcusName=' + this.getRequestData.rrmRapcusName
        + '&opmId=' + this.getRequestData.opmId + '&opmName=' + this.getRequestData.opmName
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },

    // 回退
    async puBackPuRrapplyGoBack() {
      var dataInfo = this.returnData.list[this.selectedDataIndex];
      if (!dataInfo) {
        this.$message({
          message: "请先选中要操作的数据",
          type: "error",
        });
        return false;
      }
      this.$confirm("确定要回退该订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let responseData = await this.$http.puBackPuRrapplyGoBack({
          ids: [dataInfo.rrmId],
        });
        if (responseData.status == 200) {
          this.$message({
            type: "success",
            message: responseData.message,
          });

          this.getDataList();
        } else {
          this.$message({
            message: responseData.message,
            type: "error",
          });
        }
      }).catch(() => { });
    },

    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },

    // 获取数据列表
    async getDataList() {
      if (this.getRequestData.smName == "") {
        this.getRequestData.smId = "";
      }
      if (this.getRequestData.opmName == "") {
        this.getRequestData.opmId = "";
      }
      let responseData = await this.$http.getPurchaseReimbursementHistory(
        this.getRequestData
      );
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list;
        this.returnData.pages = responseData.result.pages;
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
        this.selectedDataIndex = 0;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.requesUrl = this.$store.getters.getConfig.requestUrl;
    this.getPageInfo();

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>